var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80247 5.925L13.8346 0H12.6421L8.27275 5.14459L4.78295 0H0.757874L6.03514 7.77954L0.757874 13.9928H1.95039L6.56455 8.55995L10.25 13.9928H14.2751L8.80247 5.925ZM7.16916 7.84808L6.63446 7.07341L2.38007 0.909309H4.2117L7.64504 5.88394L8.17974 6.6586L12.6427 13.1249H10.8111L7.16916 7.84808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/x-twitter.c729a2c11655981e180f0223ebde0c1e.svg";
export { ForwardRef as ReactComponent };